module.exports = __webpack_public_path__ + "static/media/10-icon.f64cf90f.svg";